/**
 * Plugin to initialize background token refresh when user is authenticated
 * Prevents white page flashes from token expiration by refreshing tokens preemptively
 */

export default defineNuxtPlugin(async () => {
  const auth = useAuth();

  // Watch for authentication state changes
  watch(
    () => auth.user,
    (user) => {
      const tokenRefresh = useTokenRefresh();
      
      if (user) {
        // User authenticated, start token refresh
        console.log('[TokenRefreshPlugin] User authenticated, starting token refresh');
        tokenRefresh.startRefresh();
      } else {
        // User logged out, stop token refresh
        console.log('[TokenRefreshPlugin] User logged out, stopping token refresh');
        tokenRefresh.stopRefresh();
      }
    }
  );

  // Initial check on app load
  if (auth.user) {
    console.log('[TokenRefreshPlugin] App loaded with authenticated user, starting token refresh');
    const tokenRefresh = useTokenRefresh();
    tokenRefresh.startRefresh();
  }
});

